module.exports = __webpack_public_path__ + "static/media/partner-6.c8f916bd.webp";